import { SET_FE_ERROR_LOG } from "../actions/fe-error-notification-actions-types";

const INITIAL_STATE_FE_ERROR_LOG = { results: [] }

export function setFeErrorLogReducer(state = INITIAL_STATE_FE_ERROR_LOG, action) {
  switch (action.type) {
    case SET_FE_ERROR_LOG:
      return { results: action.payload };
    default:
      return state;
  }
}